import React, { createRef } from 'react';

import { InputContainer } from './styles';
export default function Input({
  onFocus,
  onBlur,
  handleInputChange,
  name,
  type,
  labelName,
  value,
  style,
  size,
  isTextArea,
  disabled,
  error,
  errorMessage,
  RightIcon,
  onClickRightIcon,
  id,
  placeholder,
  marginTop,
  maxLength,
  inputMode,
}) {
  const inputRefTextArea = createRef();

  const inputRef = createRef();

  const handleLabelClick = () => {
    if (!disabled) {
      inputRef.current?.focus();
      inputRefTextArea.current?.focus();
    }
  };

  const inputContainerStyle = {
    width: size ?? '100%',
    ...style,
  };

  const textAreaMaxLength = isTextArea ? maxLength : 500;

  return (
    <InputContainer
      style={inputContainerStyle}
      disabled={disabled}
      error={error}
      marginTop={marginTop}
    >
      <label onClick={handleLabelClick}>{labelName}</label>
      {!isTextArea && (
        <>
          <input
            type={type}
            name={name}
            onChange={handleInputChange}
            onBlur={onBlur}
            onFocus={onFocus}
            value={value}
            ref={inputRef}
            readOnly={handleInputChange === undefined}
            disabled={disabled}
            id={id}
            placeholder={!disabled ? placeholder : ''}
            maxLength={maxLength}
            inputMode={inputMode}
          />
          {RightIcon && (
            <div className='right-icon' onClick={onClickRightIcon}>
              <RightIcon />
            </div>
          )}
        </>
      )}
      {isTextArea && (
        <>
          <textarea
            id={id}
            name={name}
            onChange={handleInputChange}
            onFocus={onFocus}
            onBlur={onBlur}
            value={value}
            ref={inputRefTextArea}
            readOnly={handleInputChange === undefined}
            style={{ height: '100px', resize: 'none' }}
            disabled={disabled}
            maxLength={maxLength ?? 500}
            placeholder={!disabled ? placeholder : ''}
            inputMode={inputMode}
          />
          <label className='charactersCount'>
            {value
              ? textAreaMaxLength - value?.toString().length || 0
              : textAreaMaxLength}{' '}
            restantes
          </label>
        </>
      )}
      <span className='errorMessage'>{error && errorMessage}</span>
    </InputContainer>
  );
}
